<div
    class="primary-navigation-list navbar-nav primary-nav d-flex flex-column align-self-start justify-content-between h-100"
>
    <div class="d-flex flex-column align-self-start w-100">
        <div class="px-2 py-3 pb-lg-4 pt-lg-5 m-0">
            <nav-logo
                [isApex]="!!(isApexInstitution$ | async)"
                [isMedality]="!!(isMedalityInstitution$ | async)"
                [expanded]="expanded()"
            ></nav-logo>
        </div>
        @if (!hideNavLinks) {
            @if (hasValidExamBanks$ | async) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Performance)"
                    [routerLink]="['/performance']"
                    iconClass="fal fa-chart-line fa-lg"
                    text="Performance"
                    *hasPermission="[permissions.ViewInstitutionPerformance, permissions.ViewIndividualPerformance]"
                ></nav-item>
            }

            <nav-item
                (navItemClick)="onNavItemClicked(navItems.Learners)"
                [routerLink]="['/manage/learners']"
                iconClass="fal fa-user-graduate fa-lg"
                [text]="(learnersTab$ | async) ?? 'Learners'"
                *hasPermission="[permissions.ManageViewStudent]"
            ></nav-item>

            <nav-item
                (navItemClick)="onNavItemClicked(navItems.Faculty)"
                [routerLink]="['/manage/faculty']"
                iconClass="fal fa-landmark fa-lg"
                text="Faculty"
                *hasPermission="[permissions.ManageFaculty]"
            ></nav-item>

            @if (hasValidExamBanks$ | async) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Groups)"
                    [routerLink]="['/manage/groups']"
                    iconClass="fal fa-users fa-lg"
                    text="Groups"
                ></nav-item>
            }

            <nav-item
                (navItemClick)="onNavItemClicked(navItems.Subscriptions)"
                [routerLink]="['/manage/subscriptions']"
                iconClass="fal fa-list-alt fa-lg"
                text="Subscriptions"
                *hasPermission="[permissions.ManageSubscriptions]"
            ></nav-item>

            @if (hasValidExamBanks$ | async) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Quizzes)"
                    [routerLink]="['/quizzes']"
                    iconClass="fal fa-list-ul fa-lg"
                    text="Quizzes"
                    *hasPermission="quizzesLinkPermissions"
                ></nav-item>
            }

            @if ((canAccessCurriculums$ | async) && (hasValidExamBanks$ | async)) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Curriculum)"
                    [routerLink]="['/curriculum']"
                    iconClass="fal fa-book-open-cover fa-lg"
                    text="Curriculum"
                ></nav-item>
            }

            @if (hasValidExamBanks$ | async) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Assessments)"
                    [routerLink]="['/assessments']"
                    iconClass="fal fa-graduation-cap fa-lg"
                    text="Assessments"
                    *hasPermission="assessmentsLinkPermissions"
                ></nav-item>
            }

            <nav-item
                (navItemClick)="onNavItemClicked(navItems.Report)"
                [routerLink]="['manage/report']"
                imageSrc="assets/report.svg"
                text="Reports"
                *hasPermission="[permissions.ViewInstitutionPerformance, permissions.ViewIndividualPerformance]"
            ></nav-item>

            @if (aiFacultyFeaturesFlagEnabled && (hasValidExamBanks$ | async)) {
                <nav-item
                    id="aiToolsLink"
                    (navItemClick)="toggleAiToolsSubmenu()"
                    customClass="ai-tools-menu"
                    iconClass="fal fa-sparkles fa-lg"
                    text="AI Tools"
                    [hasSubmenu]="true"
                    [submenuExpanded]="aiToolsSubmenuExpanded()"
                >
                    <div class="nav-submenu">
                        <nav-item
                            id="aiPerformanceInsightsLink"
                            (navItemClick)="onNavItemClicked(navItems.AiPerformanceInsights)"
                            [routerLink]="['/ai-tools/smart-insights']"
                            imageSrc="assets/smart-insights.svg"
                            iconClass="smart-insights-img"
                            text="SmartInsights"
                            *hasPermission="performanceInsightsPermissions"
                        ></nav-item>
                    </div>
                </nav-item>
            }

            @if (hasValidExamBanks$ | async) {
                <nav-item
                    (navItemClick)="onNavItemClicked(navItems.Questions)"
                    [routerLink]="['/questions']"
                    iconClass="fal fa-list-check fa-lg"
                    text="Questions"
                    *hasPermission="questionsLinkPermissions"
                ></nav-item>
            }

            @if (contentLibraryFlagEnabled) {
                <nav-item
                    id="contentLibraryLink"
                    (navItemClick)="onNavItemClicked(navItems.ContentLibrary)"
                    [routerLink]="['/content-library']"
                    iconClass="fal fa-books fa-lg"
                    text="Content Library"
                ></nav-item>
            }

            @if (isApex$ | async) {
                <nav-item
                    id="apexLink"
                    (navItemClick)="onApexCoursesClick()"
                    imageSrc="https://d2lci6o0v9zqdl.cloudfront.net/img/Apex_white_small.svg"
                    imageStyle="height: 18px"
                    [text]="apexCoursesLabel"
                ></nav-item>
            }

            @if (!!picmonicDashboardUrl()) {
                <nav-item
                    (navItemClick)="onPicmonicLinkClick()"
                    customClass="picmonic-nav-link"
                    imageSrc="https://d2lci6o0v9zqdl.cloudfront.net/img/Picmonic_white_small.svg"
                    imageStyle="height: 18px"
                    text="Picmonic"
                ></nav-item>
            }

            <nav-item
                (navItemClick)="onNavItemClicked(navItems.Collapse)"
                [iconClass]="'fal fa-lg ' + (expanded() ? 'fa-chevron-double-left' : 'fa-chevron-double-right')"
                [ariaLabel]="expanded() ? 'Collapse sidebar' : 'Expand sidebar'"
                customClass="d-none d-lg-flex"
                text="Collapse"
            ></nav-item>
        }
    </div>
    <div id="resourceCenter" class="resource-center"></div>
</div>

<ng-template #apexCoursesLabel>
    <span class="text-capitalize" style="color: #f8f2bb">APEX Courses</span>
</ng-template>
